import React from "react";
import LogInForm from "../components/LogInForm";
require("../components/LoginForm.css");

export default function Login() {
  return <LogInForm />;
}
